<!-- The inline "New format" field: with several projects to choose from, "in project" and one pill per project
     (ProjectPills.vue); then the name field (40 characters), the colour swatches (SERIES_COLORS), ✓ and ×. Enter or ✓
     emits confirm with the typed name (the owner creates the format); Esc or × emits cancel (Esc goes no further). It
     takes the cursor when it appears and after a colour or project is picked. The owner keeps the colour and the
     project and shows or hides the field. Used by the plan's filter bar (PedFilters.vue) and the video dialog's format
     field (FormatPicker.vue). -->
<script setup lang="ts">
import { onMounted, ref } from 'vue'
import ProjectPills from './ProjectPills.vue'
import { useI18n } from '../../composables/useI18n'
import { SERIES_COLORS } from '../../utils/color'
import type { Project } from '../../data/types'

withDefaults(defineProps<{ color: string; projects?: Project[]; project?: string; inputId?: string }>(), { projects: () => [], project: '', inputId: undefined })
const emit = defineEmits<{ 'pick-color': [color: string]; 'pick-project': [pid: string]; confirm: [name: string]; cancel: [] }>()
const { t } = useI18n()

const name = ref('')
const input = ref<HTMLInputElement | null>(null)
onMounted(() => input.value?.focus())
function pickColor(c: string) { emit('pick-color', c); input.value?.focus() }
function pickProject(pid: string) { emit('pick-project', pid); input.value?.focus() }
function confirm() { const n = name.value; name.value = ''; emit('confirm', n) }
</script>

<template>
  <span class="inline-flex flex-wrap items-center gap-1.5 bg-darkcard border border-brand rounded-2xl px-2 py-1.5">
    <ProjectPills :projects="projects" :pid="project" @pick="pickProject" />
    <input :id="inputId" ref="input" v-model="name" maxlength="40" :placeholder="t('Format name')" class="bg-transparent text-xs text-gray-100 w-36 focus:outline-none px-1"
      @keydown.enter.prevent="confirm" @keydown.esc.stop="emit('cancel')">
    <button v-for="c in SERIES_COLORS" :key="c" type="button" :title="t('Colour')" :class="['w-5 h-5 rounded-full', { 'ring-2 ring-offset-2 ring-offset-darkcard ring-gray-100': c === color }]" :style="{ background: c }" @click="pickColor(c)"></button>
    <button type="button" :title="t('Create')" class="w-6 h-6 rounded-full bg-brand text-white text-[10px]" @click="confirm"><i class="fas fa-check"></i></button>
    <button type="button" :title="t('Cancel')" class="w-6 h-6 rounded-full bg-darkbtn text-gray-400 text-[10px]" @click="emit('cancel')"><i class="fas fa-xmark"></i></button>
  </span>
</template>
